/**
 * Episodios como CSV, para abrir en Excel.
 *
 * Función pura. Dos decisiones que parecen manías y no lo son:
 *
 *  - **Separador punto y coma.** Excel en configuración regional española
 *    espera `;`, no `,`. Con coma, todo el archivo cae en una sola columna y
 *    el asesor concluye que la exportación está rota.
 *  - **BOM al principio.** Sin él, Excel lee el UTF-8 como latin-1 y las
 *    tildes salen como `Ã³`. Tres bytes que evitan una llamada de soporte.
 */

import type { DrivingAnalysisV5 } from "../pipeline/driving-analysis-v5.ts";

export const CSV_BOM = "﻿";

const TYPE_LABEL: Record<string, string> = {
  acceleration_candidate: "Aceleración",
  braking_candidate: "Frenada",
  left_turn_candidate: "Giro a la izquierda",
  right_turn_candidate: "Giro a la derecha",
  elevated_speed_candidate: "Velocidad elevada",
};

const SEVERITY_LABEL: Record<string, string> = {
  low: "Baja",
  moderate: "Moderada",
  high: "Alta",
  critical: "Crítica",
  inconclusive: "Inconclusa",
};

/** Entrecomilla si hace falta y duplica las comillas internas, como manda RFC 4180. */
function cell(value: string | number | null): string {
  if (value === null) return "";
  const text = String(value);
  return /[";\n\r]/u.test(text) ? `"${text.replace(/"/gu, '""')}"` : text;
}

export function buildEpisodesCsv(
  analysis: DrivingAnalysisV5,
  vehicle: { plate: string | null; deviceId: string },
): string {
  const header = [
    "placa",
    "dispositivo",
    "episodio",
    "tipo",
    "severidad",
    "inicio",
    "fin",
    "candidatos",
    "tramos",
    "firma_periodo_desde",
    "firma_periodo_hasta",
  ];

  const rows = analysis.technicalDriving.episodes.map((episode) =>
    [
      vehicle.plate,
      vehicle.deviceId,
      episode.id,
      TYPE_LABEL[episode.type] ?? episode.type,
      SEVERITY_LABEL[episode.severity] ?? episode.severity,
      episode.start,
      episode.end,
      episode.candidateCount,
      episode.segmentCount,
      analysis.period.requestedFrom,
      analysis.period.requestedTo,
    ]
      .map(cell)
      .join(";"),
  );

  return CSV_BOM + [header.join(";"), ...rows].join("\r\n") + "\r\n";
}
